import { Entity, SaveChangesSuccessCallback, SaveOptions, SaveChangesErrorCallback, SaveResult } from "breeze";
import { Auth401Service } from "../shared/auth/auth401.service";
import { of } from "rxjs/observable/of";
import { IQService } from "angular";

export function initialize(module: ng.IModule) {
    module.service(EntityManagerService.Id, EntityManagerService);

    EntityManagerService.$inject = ["breeze", "serviceConfig", "$q", "auth401Service"];
}

type SaveChangesSignature = (entities?: Entity[], saveOptions?: SaveOptions, callback?: SaveChangesSuccessCallback, errorCallback?: SaveChangesErrorCallback) => breeze.promises.IPromise<SaveResult>;

export class EntityManagerService implements IEntityManagerService {

    private entityManager: breeze.EntityManager;

    public static Id = "entityManagerService";

    constructor(
        private breeze,
        private serviceConfig,
        private $q: IQService,
        private auth401Service: Auth401Service) { }

    public getEntityManager(auth401HandlerErrorCallback?: () => void) {
        // Ensure that there is ony ONE EntityManager (singleton instance)
        if (!this.entityManager) {
            this.entityManager = new this.breeze.EntityManager(this.serviceConfig.oDataUrl);

            // Disable client-side validation
            var validationOptions = this.entityManager.validationOptions.using({ validateOnAttach: false, validateOnSave: false });
            this.entityManager.setProperties({ validationOptions: validationOptions });

            let currentSaveChanges: SaveChangesSignature = this.entityManager.saveChanges.bind(this.entityManager);

            let newSaveChanges = (entities?: Entity[], saveOptions?: SaveOptions, callback?: SaveChangesSuccessCallback, errorCallback?: SaveChangesErrorCallback): breeze.promises.IPromise<SaveResult> => {
                return currentSaveChanges(entities, saveOptions, callback, errorCallback)
                    .catch<SaveResult>(error => {
                        if (error && (error.status === 401 || Number(error.status) === 401)) {
                            const deferred = this.$q.defer<SaveResult>();
                            this.auth401Service
                                .handle401Error(
                                    () => of(currentSaveChanges(entities, saveOptions, callback, errorCallback)),
                                    error,
                                    true,
                                    undefined,
                                    auth401HandlerErrorCallback)
                                .subscribe(
                                    saveResultPromise => deferred.resolve(saveResultPromise),
                                    err => deferred.reject(err));
                            return deferred.promise as breeze.promises.IPromise<SaveResult>;
                        }
                        throw error;
                    });
            };

            this.entityManager.saveChanges = newSaveChanges;
        }

        return this.entityManager;
    }

    public get serviceName() {
        return this.serviceConfig.oDataUrl;
    }
}

export interface IEntityManagerService {
    getEntityManager(): breeze.EntityManager;
    
    serviceName: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/breeze.entitymanager.service.ts